import { useRef, useState } from "react";
import {
    IFiltroAtendimentos,
    TModoGestaoAtendimento,
} from "../../../../Interfaces/AssistenciaTecnica/Atendimento/AtendimentoInterfaces";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { ListarAtendimentosAssisTecController } from "../../../../Controllers/AssistenciaTecnica/GestaoDeAtendimento/GestaoDeAtendimentoController";
import usePaginationFilter from "../../../../hooks/usePaginationFilter";
import { TableChangeState } from "react-bootstrap-table-next";

interface IPropsTableChange extends TableChangeState<any> {
    searchText: string;
}

export interface IFormData {
    ID_CASO?: number;
    ID_CONTA?: number;
    DT_INICIO_IN?: string;
    DT_INICIO_FN?: string;
    DT_FIM_IN?: string;
    DT_FIM_FN?: string;
    DS_STATUS_SOLICITACAO?: string;
    DS_CONTA?: string;
    DS_CONTATO?: string;
    ID_USUARIO_RESPONSAVEL?: number;
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS?: number;
    ID_EMPREENDIMENTO?: Array<{
        label: string;
        value: number;
    }>;
    PESQUISA?: string;
    ID_TIPO_CANAL_ATENDIMENTO?: number;
}

export function useAtendimentosAssistencia(props: TModoGestaoAtendimento) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const [pesquisaText, setPesquisaText] = useState("");
    const todaysDate = new Date();
    //instancia um objeto date de 3 meses antes da data de hoje
    const pastDate = new Date(new Date().setMonth(todaysDate.getMonth() - 3));
    const filtroInicial = {
        DT_INICIO: pastDate.toISOString().substring(0, 10),
        DT_FIM: todaysDate.toISOString().substring(0, 10),
        ID_CASO: 0,
        ID_CONTA: 0,
        ID_USUARIO_RESPONSAVEL: 0,
        DS_STATUS_SOLICITACAO: "Aberto",
        DS_CONTA: "",
        DS_CONTATO: "",
        ID_EMPREENDIMENTO: [0],
    };

    const FILTRO_ATENDIMENTOS = sessionStorage.getItem(
        "FILTRO_ATENDIMENTOS_ASSITENCIA_TECNICA"
    );

    const { PageFilter, setPage, filter, setFilter, page } =
        usePaginationFilter<IFiltroAtendimentos>({
            page: 1,
            filter: FILTRO_ATENDIMENTOS
                ? JSON.parse(FILTRO_ATENDIMENTOS)
                : filtroInicial,
        });

    const {
        value: lstAtendimentos,
        loading,
        execute,
    } = useAsyncEffect(() => {
        return ListarAtendimentosAssisTecController(
            filter ?? {},
            page ?? 1,
            props
        );
    }, [PageFilter, page]);

    const totalPaginas = lstAtendimentos?.ATENDIMENTOS?.[0]?.NR_PAGINAS || 1;

    const handleDateChange = (formData: IFormData) => {
        const filterFormData: IFiltroAtendimentos = {
            ID_CONTA:
                formData.ID_CONTA && formData.ID_CONTA > 0
                    ? formData.ID_CONTA
                    : 0,

            ID_CASO:
                formData.ID_CASO && formData.ID_CASO > 0 ? formData.ID_CASO : 0,
            ID_USUARIO_RESPONSAVEL:
                formData.ID_USUARIO_RESPONSAVEL &&
                formData.ID_USUARIO_RESPONSAVEL > 0
                    ? formData.ID_USUARIO_RESPONSAVEL
                    : 0,
            DS_STATUS_SOLICITACAO:
                formData.DS_STATUS_SOLICITACAO &&
                formData.DS_STATUS_SOLICITACAO?.length > 0
                    ? formData.DS_STATUS_SOLICITACAO
                    : "",
            DS_CONTA:
                formData.DS_CONTA && formData.DS_CONTA?.length > 0
                    ? formData.DS_CONTA
                    : "",
            DS_CONTATO:
                formData.DS_CONTATO && formData.DS_CONTATO?.length > 0
                    ? formData.DS_CONTATO
                    : "",
            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS:
                formData.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS,
            ID_EMPREENDIMENTO: formData.ID_EMPREENDIMENTO?.map(
                (value) => value.value
            ),
            ID_TIPO_CANAL_ATENDIMENTO:
                formData.ID_TIPO_CANAL_ATENDIMENTO &&
                formData.ID_TIPO_CANAL_ATENDIMENTO > 0
                    ? formData.ID_TIPO_CANAL_ATENDIMENTO
                    : 0,
            // FL_CONTEM: naoContem,
        };
        if (formData.DT_FIM_IN) {
            filterFormData.DT_FIM_IN = formData.DT_FIM_IN;
        }
        
        if (formData.DT_FIM_FN) {
            filterFormData.DT_FIM_FN = formData.DT_FIM_FN;
        }
    
        if (formData.DT_INICIO_IN) {
            filterFormData.DT_INICIO_IN = formData.DT_INICIO_IN;
        }
    
        if (formData.DT_INICIO_FN) {
            filterFormData.DT_INICIO_FN = formData.DT_INICIO_FN;
        }
        setFilter(filterFormData);
        sessionStorage.setItem(
            "FILTRO_ATENDIMENTOS_ASSITENCIA_TECNICA",
            JSON.stringify(filterFormData)
        );
    };

    const ultimaPesquisaRef = useRef("");
    // const [naoContem, setNaoContem] = useState<boolean>(true);

    function handleSearch(
        searchValue: string,
        newState: IPropsTableChange
        // contem: boolean
    ) {
        ultimaPesquisaRef.current = searchValue;

        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                setFilter({
                    ...filter,
                    PESQUISA: newState.searchText,
                    // FL_CONTEM: naoContem,
                    DT_FIM_IN: filter?.DT_FIM_IN,
                    DT_FIM_FN: filter?.DT_FIM_FN,

                    DT_INICIO_IN: filter?.DT_INICIO_IN,
                    DT_INICIO_FN: filter?.DT_INICIO_FN,
                });
                setPage(newState.page);
            }
        }, 1500);
    }

    return {
        show,
        setShow,
        modal,
        setModal,
        lstAtendimentos,
        handleSearch,
        setPesquisaText,
        pesquisaText,
        loading,
        totalPaginas,
        setFilter,
        setPage,
        FILTRO_ATENDIMENTOS,
        filter,
        handleDateChange,
        filtroInicial,
        execute,
    };
}
